import { useGlobalContext } from './GlobalContext';

export const useSkipOptions = (): {
  skipOptions:
    | CustomerPortalSettings['skipOptions']['skipOptionsIntervals']
    | null;
} => {
  const { customerPortalSettings } = useGlobalContext();
  const skipOptions = customerPortalSettings?.skipOptions?.skipOptionsEnabled
    ? customerPortalSettings?.skipOptions?.skipOptionsIntervals
    : null;

  return {
    skipOptions,
  };
};
